import { bootcampsData } from './bootcampsData'

export const minibootcampsData = [
  {
    id: '1',
    topic: 'DSA',
    description:
      'Master in Data Structure and Algorithms with 200+ hand on created questions',
    badges: ['2 months', '10+ Projects', '200+ Questions'],
    prices: '₹ 5,000',
    to: bootcampsData.dsa.explore
  },
  {
    id: '2',
    topic: 'Frontend',
    description:
      'Master in Data Structure and Algorithms with 200+ hand on created questions',
    badges: ['2 months', '10+ Projects', '200+ Questions'],
    prices: '₹ 5,000',
    to: bootcampsData.frontend.explore
  },
  {
    id: '3',
    topic: 'Backend',
    description:
      'Master in Data Structure and Algorithms with 200+ hand on created questions',
    badges: ['2 months', '10+ Projects', '200+ Questions'],
    prices: '₹ 5,000',
    to: bootcampsData.backend.explore
  }
]
